(() => {
  const MODAL_SELECTOR = '.modern-header__search-modal-host details-modal.header__search';
  const ROOT_OPEN_CLASS = 'search-modal-open';

  function getSearchModal() {
    return document.querySelector(MODAL_SELECTOR) || document.querySelector('details-modal.header__search');
  }

  function setRootOpenState(isOpen) {
    document.documentElement.classList.toggle(ROOT_OPEN_CLASS, !!isOpen);
  }

  function wireModalStateSync(modal) {
    if (!modal || modal.nodeType !== 1) return;
    if (modal.dataset && modal.dataset.modernSearchWired === '1') return;
    if (modal.dataset) modal.dataset.modernSearchWired = '1';

    const details = modal.querySelector('details');
    if (!details) return;

    const sync = () => setRootOpenState(details.hasAttribute('open'));
    details.addEventListener('toggle', sync);
    sync();
  }

  function clearPredictiveResults(modal) {
    const predictive = modal?.querySelector('predictive-search');
    if (predictive && typeof predictive.close === 'function') {
      try {
        predictive.close(true);
      } catch (_) {
        // no-op
      }
    }
  }

  function clearAndFocus(modal) {
    if (!modal) return;

    const input = modal.querySelector('input[type="search"][name="q"]');
    if (input) {
      input.value = '';
      // Safari can be picky about Event constructors in older builds; fall back if needed.
      try {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (_) {
        const evt = document.createEvent('Event');
        evt.initEvent('input', true, true);
        input.dispatchEvent(evt);
      }
    }

    clearPredictiveResults(modal);

    // Let details-modal trapFocus run first.
    setTimeout(() => {
      const nextInput = modal.querySelector('input[type="search"][name="q"]');
      nextInput?.focus?.();
    }, 0);
  }

  function openModal(modal) {
    if (!modal) return;
    wireModalStateSync(modal);
    const summary = modal.querySelector('summary');
    if (!summary) return;

    if (typeof modal.open === 'function') {
      modal.open({ target: summary });
    } else {
      // Fallback: click summary to open
      summary.click();
    }

    // Ensure root state updates even if 'toggle' doesn't fire.
    setRootOpenState(true);
    clearAndFocus(modal);
  }

  function onTriggerClick(e) {
    const trigger = e.target.closest('[data-open-search-modal]');
    if (!trigger) return;

    e.preventDefault();

    // Close mobile nav drawer if open (function exists in this theme)
    if (typeof window.closeMobileNav === 'function') {
      try {
        window.closeMobileNav();
      } catch (_) {
        // no-op
      }
    }

    openModal(getSearchModal());
  }

  document.addEventListener('click', onTriggerClick);
})();

